import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Cycle} from '@services/model/cycle';
import moment from 'moment';
import {isSome, Option} from 'fp-ts/lib/Option';
import {Application} from '@services/model/application';
import Required from '@util/decorators/required';
import {ProductStatus} from '@services/model/product';
import {CommonModule} from '@angular/common';
import {MarkantElementsModule} from '@markant/elements-angular';
import {OptionPipe} from '@util/pipes/option-pipe';
import {MomentPipe} from '@util/pipes/moment-pipe';

/* representational component */
@Component({
  selector: 'app-status-panel',
  templateUrl: './status-panel.component.html',
  styleUrls: ['./status-panel.component.scss'],
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, OptionPipe, MomentPipe],
})
export class StatusPanelComponent {
  @Required @Input() cycle: Cycle;
  @Required @Input() application: Option<Application>;

  @Output() applyCycle: EventEmitter<void> = new EventEmitter<void>();

  get daysUntilApplicationEnd(): number {
    const d = moment.duration(this.cycle.applicationEnd.diff(moment()));
    return Math.floor(d.asDays());
  }

  get buttonStatus(): 'apply' | 'applydisabled' | 'thanks' | undefined {
    if (isSome(this.application)) {
      return 'thanks';
    }
    if (this.inApplicationPeriod(this.cycle)) {
      return 'apply';
    }
    return 'applydisabled';
  }

  beforeApplicationOpen(c: Cycle): boolean {
    return moment().isBefore(c.applicationStart);
  }

  afterApplicationClosed(c: Cycle): boolean {
    return moment().isAfter(c.applicationEnd);
  }

  inApplicationPeriod(c: Cycle): boolean {
    const now = moment();
    return now.isBetween(c.applicationStart, c.applicationEnd);
  }

  apply(): void {
    this.applyCycle.emit();
  }

  shouldShowApplyInfoText(): boolean {
    if (!isSome(this.application)) {
      return true;
    }
    const app = this.application.value;
    return app.productStatus === ProductStatus.created;
  }
}
